import React from 'react';

import ArrowBackCircle from 'assets/icons/arrow-back-circle.svg?react';
import CompanyIcon from 'assets/icons/company-icon.svg?react';
import ClientIcon from 'assets/icons/client-icon.svg?react';
import ContactUsIcon from 'assets/icons/contactus-icon.svg?react';
import CalendarIcon from 'assets/icons/calendar-icon.svg?react';
import ToolboxIcon from 'assets/icons/toolbox-icon.svg?react';
import TransactionIcon from 'assets/icons/transaction-icon.svg?react';
import RightArrowIcon from 'assets/icons/right-arrow-icon.svg?react';
import LinkIcon from 'assets/icons/link-icon.svg?react';
import RemoveIcon from 'assets/icons/remove-icon.svg?react';
import ModifyIcon from 'assets/icons/modify-icon.svg?react';
import DownloadIcon from 'assets/icons/download-icon.svg?react';
import FavoriteIcon from 'assets/icons/favorite-icon.svg?react';
import LeftArrowIcon from 'assets/icons/left-arrow-icon.svg?react';
import EmailIcon from 'assets/icons/email-icon.svg?react';
import PhoneIcon from 'assets/icons/phone-icon.svg?react';
import DownCaretIcon from 'assets/icons/down-caret-icon.svg?react';
import WarningIcon from 'assets/icons/warning-icon.svg?react';
import CollapseMenuIcon from 'assets/icons/collapse-menu-icon.svg?react';
import PhoneWhiteIcon from 'assets/icons/phone-icon-white.svg?react';
import FaxIcon from 'assets/icons/fax-icon.svg?react';
import FaxWhiteIcon from 'assets/icons/fax-icon-white.svg?react';
import FilterIcon from 'assets/icons/filter-icon.svg?react';
import SuccessSeverityIcon from 'assets/icons/success-severity-icon.svg?react';
import WarningSeverityIcon from 'assets/icons/warning-severity-icon.svg?react';
import DangerSeverityIcon from 'assets/icons/danger-severity-icon.svg?react';
import InfoSeverityIcon from 'assets/icons/info-severity-icon.svg?react';

type IconName =
  | 'arrowBackCircle'
  | 'company'
  | 'clients'
  | 'toolbox'
  | 'transaction'
  | 'contactUs'
  | 'calendar'
  | 'rightArrow'
  | 'link'
  | 'remove'
  | 'download'
  | 'favorite'
  | 'leftArrow'
  | 'email'
  | 'phone'
  | 'phoneWhite'
  | 'downCaret'
  | 'warning'
  | 'collapseMenu'
  | 'fax'
  | 'faxWhite'
  | 'filter'
  | 'successSeverity'
  | 'warningSeverity'
  | 'dangerSeverity'
  | 'infoSeverity'
  | 'modify';

const nameToIcon: Record<IconName, React.FC> = {
  fax: FaxIcon,
  faxWhite: FaxWhiteIcon,
  phoneWhite: PhoneWhiteIcon,
  arrowBackCircle: ArrowBackCircle,
  remove: RemoveIcon,
  modify: ModifyIcon,
  link: LinkIcon,
  company: CompanyIcon,
  clients: ClientIcon,
  toolbox: ToolboxIcon,
  transaction: TransactionIcon,
  contactUs: ContactUsIcon,
  calendar: CalendarIcon,
  rightArrow: RightArrowIcon,
  download: DownloadIcon,
  favorite: FavoriteIcon,
  leftArrow: LeftArrowIcon,
  email: EmailIcon,
  phone: PhoneIcon,
  downCaret: DownCaretIcon,
  warning: WarningIcon,
  collapseMenu: CollapseMenuIcon,
  filter: FilterIcon,
  successSeverity: SuccessSeverityIcon,
  warningSeverity: WarningSeverityIcon,
  dangerSeverity: DangerSeverityIcon,
  infoSeverity: InfoSeverityIcon,
};

type Props = {
  name: IconName;
};

function Icon({ name }: Props) {
  const IconForName = nameToIcon[name];
  return <IconForName />;
}

export default Icon;
